import ShippingOptions from './DistributionOptions';
import { withI18n } from 'react-i18next';

export default withI18n()(ShippingOptions);
